export default "__VITE_ASSET__HkQN7S9F__"